import { ISiteConfig } from "@finbackoffice/fe-core";
import { useRuntimeConfig } from "./useRuntimeConfig";

export const useSiteConfig = <T>(name: keyof ISiteConfig) => {
    const SITE_CONFIG = useRuntimeConfig("SITE_CONFIG");
    return SITE_CONFIG[name] as T;
};
